import { DropdownValue, OrganizationType, OrganizationTypes } from "../types";

const ORGANIZATION_TYPE_OPTIONS: DropdownValue<OrganizationType>[] =
  OrganizationTypes.map((type) => ({
    label: type,
    value: type,
  }));

export default ORGANIZATION_TYPE_OPTIONS;
